import React from "react";
import { Box, Stepper, Step, StepLabel } from "@mui/material";
import { styled } from "@mui/material/styles";
import { ColorsConstants } from "../cssUtils/constants";
import typography from "../cssUtils/typography";

const AppStepper = ({
  steps = [],
  activeStep = 0,
}) => {
  return (
    <Stepper
      activeStep={activeStep}
      sx={{
        "& .MuiStepIcon-root": {
          color: "#E5E7EB",
          "&.Mui-active": {
            color: ColorsConstants.primaryBackgroundColor,
          },
          "&.Mui-completed": {
            color: ColorsConstants.primaryBackgroundColor,
          },
        },
        "& .MuiStepIcon-text": {
          ...typography.bodyLarge,
          fill: "#FFFFFF",
          fontWeight: 600,
        },
        "& .MuiStepLabel-label": {
          ...typography.bodyLarge,
          color: "#6B7280",
          fontWeight: 500,
          "&.Mui-active": {
            color: "#1F2937",
            fontWeight: 600,
          },
          "&.Mui-completed": {
            color: "#1F2937",
            fontWeight: 500,
          },
        },
      }}
    >
      {steps.map((label, index) => (
        <Step key={index}>
          <StepLabel>{label}</StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};

export default AppStepper;